interface IPinIcon {
  pinned?: boolean;
  color?: string;
}

export const PinIcon = (props: IPinIcon) => {
  const { pinned, color = '#354052' } = props;
  return pinned ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 3.75065L9.16667 7.08398L5.83333 8.33398L4.58333 9.58398L10.4167 15.4173L11.6667 14.1673L12.9167 10.834L16.25 7.50065"
        fill="#222530"
      />
      <path d="M7.5 12.5007L3.75 16.2507L7.5 12.5007Z" fill="#222530" />
      <path d="M12.0833 3.33398L16.6667 7.91732L12.0833 3.33398Z" fill="#222530" />
      <path
        d="M12.5 3.75065L9.16667 7.08398L5.83333 8.33398L4.58333 9.58398L10.4167 15.4173L11.6667 14.1673L12.9167 10.834L16.25 7.50065M7.5 12.5007L3.75 16.2507M12.0833 3.33398L16.6667 7.91732"
        stroke="#222530"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 3.75065L9.16667 7.08398L5.83333 8.33398L4.58333 9.58398L10.4167 15.4173L11.6667 14.1673L12.9167 10.834L16.25 7.50065M7.5 12.5007L3.75 16.2507M12.0833 3.33398L16.6667 7.91732"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
